/*
 * @Author: randy
 * @Date: 2020-07-31 13:59:40
 * @LastEditTime: 2020-08-28 10:07:29
 * @Description: user
 */
import {
  login,
  logout,
  getPermissions,
  loginAddSmsCode,
  loginByWechat,
  bindPhoneByWechat,
  pswLogin,
  register
} from "@/api/user";
import {
  ACCESS_TOKEN,
  USER,
  BASE,
  SET_TOKEN,
  SET_USER,
  SET_BASE,
  SET_PERMISSIONS,
  CLEAR_ALL_TAG
} from "@/store/types";
import { setStorageItem, removeStorageItem } from "@/utils/storage";
import { devRoutes } from "@/router/admin_routes";
import { resetRouter } from "@/router";

const user = {
  state: {
    token: "",
    user: null,
    base: null,
    permissions: null
  },

  mutations: {
    [SET_TOKEN]: (state, token) => {
      state.token = token;
    },
    [SET_USER]: (state, payload) => {
      state.user = payload;
    },
    [SET_BASE]: (state, base) => {
      state.base = base;
    },
    [SET_PERMISSIONS]: (state, payload) => {
      state.permissions = payload;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            // 存储七天token
            // setExpiredStorageItem(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000);
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            // mock headImg
            // user.headImg =
            //   "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
            const base = result.base;
            // 存储用户信息
            user.roleId = 1;
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //账号密码登录
    passwordLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        pswLogin(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            const base = result.trainer;
            // 存储用户信息
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 注册登录
    registerLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        register(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            const base = result.trainer;
            // 存储用户信息
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loginAddSmsCode({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginAddSmsCode(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            // 存储七天token
            // setExpiredStorageItem(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000);
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            // mock headImg
            // user.headImg =
            //   "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
            const base = result.trainer;
            // 存储用户信息
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);

            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    wechatLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByWechat(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            // 存储七天token
            // setExpiredStorageItem(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000);
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            // mock headImg
            // user.headImg =
            //   "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
            const base = result.trainer;
            // 存储用户信息
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);

            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    bindPhoneWechatLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        bindPhoneByWechat(userInfo)
          .then(response => {
            const result = response.results;
            const token = result.token;
            // 存储七天token
            // setExpiredStorageItem(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000);
            setStorageItem(ACCESS_TOKEN, token);
            commit(SET_TOKEN, token);
            const user = result;
            // mock headImg
            // user.headImg =
            //   "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
            const base = result.trainer;
            // 存储用户信息
            setStorageItem(USER, user);
            setStorageItem(BASE, base);
            commit(SET_USER, user);
            commit(SET_BASE, base);

            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户权限信息
    GetUserPermission({ commit }) {
      return new Promise((resolve, reject) => {
        getPermissions()
          .then(response => {
            const result = response.results.concat(devRoutes);

            // 存储用户权限信息
            commit(SET_PERMISSIONS, result);

            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit }) {
      let params = {
        source: "PC"
      };
      const clear = () => {
        // 清除本地存储 用户信息和token
        removeStorageItem(ACCESS_TOKEN);
        removeStorageItem(USER);
        removeStorageItem(BASE);
        // 清除store用户信息和token和菜单
        commit(SET_TOKEN, "");
        commit(SET_USER, null);
        commit(SET_BASE, null);
        commit(SET_PERMISSIONS, null);
        // 清除tag historyTags
        commit(CLEAR_ALL_TAG);
        // 重置路由
        resetRouter();
      };
      return new Promise(resolve => {
        logout(params)
          .then(() => {
            clear();
            resolve();
          })
          .catch(() => {
            clear();
            resolve();
          });
      });
    }
  }
};

export default user;
